import { render, staticRenderFns } from "./ContainerTrucking.vue?vue&type=template&id=494164c8"
import script from "./ContainerTrucking.vue?vue&type=script&lang=js"
export * from "./ContainerTrucking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports